import React from "react";
import styled from "styled-components";
import JournalCard from "../../../pages/journal/components/JournalCard";
import { useNavigate } from "react-router-dom";
import fontSize from "../../../theme/fonts/FontTheme";
import journals from "../../../assets/store/journals";
import SecondaryButton from "../../buttons/SecondaryButton";

const Wrapper = styled.section``;

const Container = styled.div`
  display: flex;
  padding: 0px 40px;
  gap: 40px;
  flex-direction: column;
  align-items: center;

  @media (max-width: 950px) {
    padding: 20px;
  }
`;

const Heading = styled.h2`
  font-weight: 400;
  text-align: center;
  font-size: ${fontSize.m};
`;

const Row = styled.div`
  display: grid;
  row-gap: 64px;
  column-gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 950px) {
    row-gap: 54px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;
function NewsLetterSection() {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <Container>
        <Heading>READ OUR NEWSLETTER</Heading>
        <Row>
          {journals.map((journal) => (
            <JournalCard key={journal} journal={journal} />
          ))}
        </Row>
        <SecondaryButton
          title={"View All"}
          onClick={() => {
            navigate("/journal");
          }}
        />
      </Container>
    </Wrapper>
  );
}

export default NewsLetterSection;
